<template>
  <div>
    <div class="box loginDiv">
      <header class="loginTitle">
        <img src="../../static/images/loginCodeLogo.png" />
      </header>
      <el-form class="self-form">
        <el-input v-model.trim="signUpUserMsg.tel" type="tel" placeholder="请输入手机号" @input="changeInput()" class="same-col" maxlength="11"></el-input>
        <div class="loginTip">{{loginTipShow==1?loginTipWord:''}}</div>
        <el-input class="same-col" v-model.trim="signUpUserMsg.telCode" @input="changeInput()" placeholder="请输入6位验证码" maxlength="6">
          <el-button type="text"  class="suffix_button" :class="codeBtn&&'grayWords'" slot="suffix" :disabled="codeBtn" size="small" @click="sendCode">{{codeWords}}</el-button> 
        </el-input>
        <div class="loginTip">{{loginTipShow==2?loginTipWord:''}}</div>
        <div class="userCheckboxDiv tw-flex" @click="checkedImgBtn"><img :src="userAgreeChecked?require('../../static/images/is-checked.png'):require('../../static/images/empty-checked.png')" /><div class="works font10px">同意并接受<a :href="$axiosUrl.UserAgreementSrc" target="_blank">《用户协议》</a>和<a :href="$axiosUrl.PrivacyTermsSrc" target="_blank">《隐私条款》</a></div></div>
        <div class="loginTip">{{loginTipShow==3?loginTipWord:''}}</div>
        <el-button type="primary" :loading="sureLoginBtnLoading" @click="sureLogin" size="large" class="login-button linearBtnBg">登录</el-button>
        
      </el-form>
      
    </div>
  </div>
</template>

<script>
import { successMsg } from '../utils/confirm'
export default {
  data () {
    return {
      signUpUserMsg: {
        tel: '',
        telCode: ''
      },
      isLoading: false,
      codeBtn: false, // 发送按钮时候是禁用
      countdown: 60, // 倒计时
      codeWords: '获取验证码', // 发送验证码文字
      sureLoginBtnLoading: false, // 登录按钮样式
      loginTipShow: 0, // 0不显示 1手机号 2验证码 3同意协议
      userAgreeChecked: false, // 是否选择同意协议
      loginTipWord: '',
      timeStop: '' // 定时器
    }
  },
  props: {
    fromPath: { // 登录成功后跳转路径
      type: String,
      default: ''
    },
  },
  created () {
  },
  methods: {
    sureLogin () {
      var that = this
      console.log(that.signUpUserMsg)
      console.log(that.userAgreeChecked)
      if(!that.signUpUserMsg.tel) {that.loginTipShow = 1; that.loginTipWord = '请输入正确的手机号'; return}
      if(!that.signUpUserMsg.telCode) {that.loginTipShow = 2; that.loginTipWord = '请输入验证码'; return}
      if(!that.userAgreeChecked) {that.loginTipShow = 3; that.loginTipWord = '请勾选同意协议'; return}
      that.loginTipShow = 0
      that.getLoginData()
    },
    async getLoginData (){
      // 跳转页面
      let that = this
      var loginData = {phone: that.signUpUserMsg.tel, verifyCode: that.signUpUserMsg.telCode}
      console.log(loginData)
      that.sureLoginBtnLoading = true
      that.$jsonPost(that.$axiosUrl.getLogin, loginData)
        .then((response) => {
          console.log(response)
          successMsg('登录成功！')
          that.sureLoginBtnLoading = false
          that.signUpUserMsg = {tel: '',telCode: ''},
          that.codeBtn = false, // 发送按钮时候是禁用
          clearInterval(that.timeStop) // 清除定时器
          that.countdown = 60, // 倒计时
          that.codeWords = '获取验证码', // 发送验证码文字
          that.sureLoginBtnLoading = false, // 登录按钮样式
          that.userAgreeChecked = false, // 是否选择同意协议
          that.loginTipWord = '',
          that.$store.dispatch('GetBaseInfo', response.resp_data)
          // 通知父组件隐藏弹窗即可
          that.$emit('loginMsgDialogCloseBtn', 'loginPopupChild')
          if (that.fromPath) {
            console.log(that.fromPath);
            that.$router.push(that.fromPath)
          }
        }).catch(()=>{that.sureLoginBtnLoading = false})
    },
    // 发送验证码
    sendCode () {
          var that = this
          console.log(that.signUpUserMsg.tel)
          var reg = /^1[23456789]\d{9}$/
          if (reg.test(that.signUpUserMsg.tel)) {
            // 手机号正确 请求接口
            that.loginTipShow = false
            that.getCode()
          } else {
            console.log('请输入正确的手机号')
            that.loginTipShow = true
            that.loginTipWord = '请输入正确的手机号'
          }
        },
        setTime () {
          var that = this
          that.timeStop = setTimeout(function () {
            that.setTime()
          }, 1000)
          that.countdown--
          if (that.countdown === 0) {
            that.codeBtn = false // 按钮可以点击了
            that.codeWords = '重新发送'
            that.countdown = 60
            clearInterval(that.timeStop) // 清除定时器
          } else {
            that.codeBtn = true // 按钮禁止点击
            that.codeWords =  '重新发送'+that.countdown+'S'
          }
        },
        //   获取验证码
        getCode () {
          var that = this
          that.$jsonPost(that.$axiosUrl.verifyCode, {phone: that.signUpUserMsg.tel})
            .then((response) => {
              console.log(response)
              successMsg('发送成功')
              that.codeBtn = true // 按钮禁止点击
              that.setTime()
            })
        },
        changeInput () {
          this.sureLoginBtnLoading = false
        },
        checkedImgBtn() {
          this.userAgreeChecked = !this.userAgreeChecked
        }
  }
}

</script>

<style scoped lang="less">
  .box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  
  .loginTitle {
    text-align: center;
    font-size: 14px;
    img {
      width: 136px;
      height: 30px;
      margin-bottom: 44px;
    }
    .word {
      font-weight: bold;
      font-size: 48px;
    }
  }
  .suffix_button {
    height: 39px;
    margin-right: 16px;
    color: #514CFF;
    font-size: 14px;
    font-weight: normal;
  }
  .grayWords {
    font-size: 12px;
    color: rgba(40, 47, 54, 0.3);
  }
  .userCheckboxDiv {
    cursor: pointer;
    align-items: center;
    // margin-top: 20px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 9px;
    }
    .works {
      color: #464343;
      white-space:nowrap;
      a {
        color: rgba(81, 76, 255, 0.9);
      }
    }
    
  }
  .loginTip {
    font-size: 10px;
    height: 20px;
    line-height: 20px;
    color: #FB4539;
  }

//  新的
.self-form {
    width: 290px;
}
.login-button {
    display: block;
    width: 100%;
    margin-top: 25px;
    width: 290px;
    height: 51px;
    border: none;
  }

</style>
<style lang="less">
  .box .el-input__inner {
    background-color: #fff;
    border: 1px solid #7780A1;
    font-size: 14px;
    color: #606266;
    height: 39px;
    line-height: 39px;
    padding: 0;
    width: 290px;
    padding-left: 16px;
  }
  .el-input__suffix {
    height: 39px !important;
    color: #C0C4CC !important;
    top: 0 !important;
}
.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #606266;
}

</style>
